const ACTIVE_CLASS_NAME = 'show';

const cfPopup = document.querySelector('.OfferContactFormPopup');

if (cfPopup) {
    const openBtns = document.querySelectorAll('.open-contact-form-popup');
    const closeBtn = document.querySelector('.close-contact-form-popup');

    openBtns?.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            cfPopup.classList.add(ACTIVE_CLASS_NAME);
        });
    });

    closeBtn?.addEventListener('click', () => {
        cfPopup.classList.remove(ACTIVE_CLASS_NAME);
    });
}
